export default "__VITE_ASSET__9cc1515d__"